import axios from 'axios';
import authHeader from "@/service/auth-header";

class ClientProvisionService {

    async getClientProvisions(clientId) {
        return await axios.get(`/api/clientprovision/${clientId}`, {headers: authHeader()})
    }

    // async getClientsForProduct(productId) {
    //     return await axios.get(`/api/clientproduct/product/${productId}`, {headers: authHeader()})
    // }

    async createProvisionForClient(clientId, provisionId) {
        return await axios.post(`/api/clientprovision/${clientId}/${provisionId}`, null, {headers: authHeader()});
    }

    async updateSpecificProvisionForClient(id, data) {
        return await axios.put(`/api/clientprovision/${id}`, data, {headers: authHeader()});
    }

    async deleteSpecificProvisionForClient(id) {
        return await axios.delete(`/api/clientprovision/${id}`, {headers: authHeader()})
    }

}

export default new ClientProvisionService();
